module.exports = __webpack_public_path__ + "static/media/Brian_S.12827ab7.jpg";